export enum OPA_FLAG {
  // SJGROW-2815 - Dynamic Screener
  DYNAMIC_SCREENER = 'SJMAND-5363-dynamic-screener',

  // SJGROW-3366 - Promo banner split test
  SPA_PROMO_SJGROW_3366 = 'spa_promo_sjgrow_3366',

  // SJSURVEY-2375 - RepData (Research Defender) token fetch gate
  REPDATA_TOKEN_SJSURVEY_2375 = 'sjsurvey-2375',
}

export enum OPA_VARIABLE {
  // SJGROW-2815 - Dynamic Screener
  DYNAMIC_SCREENER_PROVIDERS = 'enabled_provider_list',

  // SJGROW-3366 - Promo banner split test
  SPA_SJGROW_3366_ENABLED = 'spa_sjgrow_3366_enabled',

  // SJSURVEY-2375 - RepData (Research Defender) token fetch gate
  REPDATA_TOKEN_ENABLED = 'enabled',
}
